import { Select, Spin } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { EntAnimalBreedFilter } from "../../models/filters/animalBreedFilter";
import { ISelectOption } from "../../models/utils/selectOption";
import { defaultFilterOption } from "../../utils";
import { getCookie } from "typescript-cookie";
import { useGetDataOnScroll } from "../getDataOnScrollProps/useGetDataOnScrollProps";
import { EntAnimalBreed } from "../../models/handBooks/animalBreed";
import { useLazyGetAnimalBreedListQuery } from "../../redux/api/handBooksApi/animalBreadApi";

interface IProps {
  value?: number | null;
  animalType?: number | null;
  onChange?: (e: any, a: any) => void;
  disabled?: boolean;
}

const SelectAnimalBreed = (props: IProps) => {
  const { t } = useTranslation();
  const [options, setOptions] = useState<ISelectOption[]>([]);


  const [getData] = useLazyGetAnimalBreedListQuery();
  const {
    fetching,
    data,
    setData,
    setFetching,
    setFilter,
    scrollHandler,
    setCurrentPage
  } = useGetDataOnScroll<EntAnimalBreed, EntAnimalBreedFilter>({
    initialFilter: {animalType: props.animalType ?? null} as  EntAnimalBreedFilter,
    query: getData
  });

  useEffect(() => {
    const options = Array.from(new Set(data)).map((a) => {
      return { label: getCookie('i18next') === 'ky' ? a.nameKy : a.nameRu, value: a.id ?? '' };
    });
    setOptions(options);
  }, [data]);

  const search = (value?: string) => {
    if (!value) return;
    const filter = new EntAnimalBreedFilter();
    filter.name = value;
    setFilter(filter);
    setData([]);
    setCurrentPage(0);
    setFetching(true);
  }

  const clear = () => {
    const filter = new EntAnimalBreedFilter();
    filter.name = null;
    setFilter(filter);
    setData([]);
    setCurrentPage(0);
    setFetching(true);
  }

  return (
    <Select
      disabled={props.disabled}
      placeholder={t("msg.selectPlaceholder")}
      onClear={clear}
      onSearch={search}
      onPopupScroll={scrollHandler}
      loading={fetching}
      value={props.value}
      onChange={props.onChange}
      options={options}
      filterOption={defaultFilterOption}
      showSearch
      allowClear
      dropdownRender={(menu) => (
        <Spin spinning={fetching} >
          {menu}
        </Spin>
      )}
    />
  );
};

export default SelectAnimalBreed;